import { hashDomain, hashStruct } from 'viem';
/**
 * Used mainly for Ledger Nano S
 */
export const domainHash = (message) => {
    return hashDomain({ domain: message.domain, types: message.types });
};
export const messageHash = (message) => {
    return hashStruct({
        data: message.message,
        types: message.types,
        primaryType: message.primaryType,
    });
};
